var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('option-list',{attrs:{"options":_vm.options,"entity-type":_vm.EntityType.STAGE,"entity-id":_vm.$route.params.stageId.toString()}})}
var staticRenderFns = []

export { render, staticRenderFns }